
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {getOu} from "@/utils/cookies";

  @Component({name:'UploadTemplate'})
  export default class UploadTemplate extends Vue{

    @Prop({required:true})
    templateType!:number;

    @Prop({required:false,default:'模板上传'})
    title!:string;

    @Prop({required:false,default:false})
    hiddenMonth!:boolean;

    formDateMonth = '';
    form ={
      show:false,
      submitting: false,
      data: {
        Year: "",
        Month: "",
        Target: 0
      },
      rules: {}
    };

    created(){
      this.form.data.Target = this.templateType;
    }

    get uploadHeaders(){
      return  {
        "Abp-OrganizationUnitId": (this.$store.getters['user/ouId']),
        "Abp-TenantId": this.$store.getters['app/tenantId'],
        "Abp-ManagePlatform":true,
        "Authorization" :`Bearer ${this.$store.getters['user/token']}`
      }
    }

    uploadFile() {
      this.form.show = true;
    }

    handleRemove() {}

    submitUpload() {
      if (this.hiddenMonth!==false  ) {
        this.formDateMonth = '2020-01';
      } else if(!this.formDateMonth) {
        this.$message({
          type: "error",
          message: "请选择月份"
        });
        return;
      }


      const temp = this.formDateMonth.split('-');

      this.form.data.Year =  temp[0];
      this.form.data.Month = temp[1];
      (this.$refs.upload as any).submit();
    }

    handleAvatarSuccess(res:any) {
      if (res.result.importResults && res.result.importResults.length > 0) {
        this.jumpDetail(res.result.importResults);
        this.form.show = false;
      }
    }

    handleAvatarError(res:any) {
      const json = JSON.parse(res.message);
      this.$message({
        type: "error",
        message: `上传失败!${json.error.message}`
      });
      this.form.show = false;
    }
    jumpDetail(table:any) {
      const that = this;
      const typeNum = this.$props.templatetype;
      let type = "";
      switch (typeNum) {
        case 0:
          type = "socialSecurityAssign";
          break;
        case 1:
          type = "commonReserveFundAssign";
          break;
        case 2:
          type = "incomeStatistics";
          break;
        case 3:
          type = "payrollOfPartner";
          break;
        case 4:
          type = "payrollOfSelf";
          break;
        case 5:
          type = "payrollAssign";
          break;
        case 6:
          type = "incomeRecord";
          break;
      }
      this.$router.push({
        name: "uploadTemplateDetail",
        params: {
          table: table,
          reportName: type
        }
      });
    }

  }
